const tabData = [
  {
    id: 1,
    title: "Healthcare",
    slug: "healthcare",
    content:
      "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
    bannerBtnText: "Let's Get Started",
    // "/images/industries-icons/HL7FHIR.webp"
    // "/images/industries-icons/FDA.png"
    bannerIcons: ["/images/industries-icons/HIPAA.png", "/images/industries-icons/AICPA.png", "/images/industries-icons/gdpr-act.png"],
    metaTitle:
      "Healthcare Software Development Services | Secure & Scalable Solutions",
    metaDes:
      "Build HIPAA-compliant healthcare software, including telemedicine apps, EMR systems, & patient portals. Enhance care delivery with Bitsclan",
    description:
      "We provide customized AI services & healthcare AI consulting, including EHR systems & patient management platforms, to improve care delivery, ensure compliance, & boost operational efficiency in the healthcare industry.",
    icon: "/images/heart.png",
    image: "healthcare.avif",
    bannerHeading: "Build healthcare software",
    bannerImage: "banner-image-industry.png",
    backgroundImage: `url(/images/industry-detial-banner-bg/health-care.png)`,
    discriptionSection: {
      heading: "Technology innovation",
      discription:
        "revolutionizes healthcare provider-patient interactions, empowering medical professionals to deliver cost-effective medical services. By leveraging healthcare software development services, you can automate processes, enhance efficiency & optimize facets ranging from patient data management to medical insurance.",
      cardHeading: "Healthcare Software Company",
      cardDiscripiton:
        "Healthcare industry is undergoing crucial changes with heavy penetration of emerging technology in both healthcare providers as well as patient segments. The time is now to transform your existing systems to the cloud, mobility, & IoT-driven solutions to automate business processes & manage healthcare data efficiently.Bitsclan is a prominent healthcare software development company that offers technology consultation, customization, integration, modernization & maintenance of healthcare software.With more than 24 years of experience, we have successfully served various organizations helping them improve the quality of care.",
    },
    industries: {
      shortHeading: "",
      heading: "",
      description: "",
      tabData: [
        {
          id: 1,
          slug: "healthcare",
          title: "Healthcare",
          description: "We provide customized AI services & healthcare AI consulting, including EHR systems & patient management platforms, to improve care delivery, ensure compliance, & boost operational efficiency in the healthcare industry.",
          image: "healthcare.avif",
          icon: "/images/heart.png",
        },
        // {
        //   id: 2,
        //   slug: "fintech",
        //   title: "Fintech",
        //   description: "Fintech thrives on innovation, & we’re here to drive it forward. Our AI in fintech web apps simplify complex financial processes, from secure payment systems to intelligent financial planning tools.",
        //   image: "fintech.png",
        //   icon: "/images/Fintech.png",
        // },
        {
          id: 3,
          slug: "retail-ecommerce",
          title: "E-commerce & Retail",
          description: "We help retailers leverage generative AI in e-commerce to enhance inventory management, deliver personalized shopping experiences, & optimize omnichannel platforms, driving higher sales & stronger customer loyalty.",
          icon: "/images/ecommerce-icon.png",
          image: "ecommerce.avif",
        },
        {
          id: 4,
          slug: "real-estate",
          title: "Real Estate",
          description: "We provide real estate professionals with property management systems, CRM platforms, & secure transaction solutions, & our AI ML engineers design intelligent tools to streamline operations & enhance client interactions.",
          icon: "/images/RealEstate.png",
          image: "realestate.avif",
        },
        {
          id: 5,
          slug: "automotive-logistics",
          title: "Automotive & Logistics",
          description: "Our AI automation & workflow solutions empower the automotive & logistics industries by streamlining vehicle tracking, fleet management, supply chains, & inventory workflows. From managing operations & customer communications to real-time updates & seamless coordination, we help businesses boost efficiency, reduce complexity, & deliver a smoother experience for everyone.",
          icon: "/images/automotive-icon.png",
          image: "automotive.avif",
        },
        {
          id: 6,
          slug: "education",
          title: "Education",
          description: "Education should be engaging & accessible, & our web apps make it possible. From e-learning platforms to classroom management tools, we design AI-powered education solutions that support students, educators, & institutions, bringing everyone closer to success.",
          icon: "/images/education-icon.png",
          image: "education.avif",
        },
        {
          id: 7,
          slug: "insurance",
          title: "Insurance",
          description: "We help insurance companies run better by offering AI-enabled automation & workflow solutions. We are a trusted AI automation agency, providing secure, scalable systems that can adapt to the evolving needs of the insurance industry.",
          icon: "/images/Insurance.png",
          image: "insurance.avif",
        },
        {
          id: 9,
          slug: "gaming-entertainment",
          title: "Entertainment & Gaming",
          description: "Our AI automation services for the entertainment & gaming industries optimize content management, audience analytics, & intellectual property protection, while also enhancing in-game automation, player interactions, & operations. We help businesses increase efficiency in content distribution, create better audience engagement, expand player support, & deliver smoother, more immersive experiences.",
          icon: "/images/industry-gaming-icon.png",
          image: "entertainmentMain.avif",
        },
        {
          id: 11,
          slug: "social-networking",
          title: "Social Networking",
          description: "We deliver AI automation & workflow solutions for social media platforms, increasing engagement, automating analytics, & ensuring secure data management. Our AI services enhance interactions while keeping processes efficient & secure.",
          icon: "/images/SocialNetworking.png",
          image: "Social.avif",
        },
        {
          id: 12,
          slug: "telecom",
          title: "Telecom",
          description: "Our AI automation services for the telecom sector streamline processes like billing management, network optimization, & customer relationship operations. By automating these workflows, we help telecom companies improve efficiency, reduce errors, & deliver consistently better experiences to their customers.",
          icon: "/images/Telecom.png",
          image: "telecom.avif",
        },
        {
          id: 13,
          slug: "energy",
          title: "Energy",
          description: "We provide advanced AI automation & workflow solutions for the energy sector. From smart grid management & resource optimization to secure trading platforms, our automated workflows help energy companies operate smarter & more efficiently.",
          icon: "/images/Energy.png",
          image: "energy.avif",
        },
        {
          id: 14,
          slug: "agriculture",
          title: "Agriculture",
          description: "Our smart automation solutions in the agricultural industry, help farmers optimize irrigation, monitor crops efficiently, & manage resources effectively. It can boost yields & support sustainable farming practices.",
          icon: "/images/industries-icons/Agriculture.svg",
          image: "Agriculture.avif",
        }
      ]
    },
    statsSection: {
      backgroundImage: "healthcare-counter-bg.avif",
      heading: "Lead the Future of",
      greenPart: "Digital Health",
      discription:
        "Bitsclan fosters HealthTech companies by developing custom medical applications & leveraging benefits from our proficiency in HIPAA, HITECH, HAPI/FHIR, CoPay, eFax, OWASP, IEC 62443, DICOM, ICD-10, & CPT.",
      subheading: "Your Top Healthcare",
      greenPartSubHeading: "Consulting Firm",
      stats: [
        {
          count: "650+",
          text: "Expert Minds",
        },
        {
          count: "3000+",
          text: "Global Clients",
        },
        {
          count: "4200+",
          text: "Successful Projects",
        },
        {
          count: "93%",
          text: "Client Retention Rate",
        },
      ],
    },
    industryServices: {
      heading: "Healthcare Software Development Services",
      text: "Healthcare software development services involve the design, development, & implementation of customized software solutions to enhance patient care & optimize hospital workflows. Bitsclan offers end-to-end healthcare software services & solutions to healthcare organizations, physicians, clinics, hospitals, digital health startups, & medical device infrastructures.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          title: "EMR & EHR Software Development",
          description: "Our expert developers create custom EMR & EHR systems, helping healthcare providers manage patient data, improve care coordination, & streamline workflows for a seamless patient experience.",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          title: "Custom Medical App Development",
          description: "We design tailored medical apps to enhance patient care & streamline hospital operations. Our apps are HIPAA-compliant & support scheduling, messaging, & prescription management.",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          title: "Telemedicine Platform Development",
          description: "Our telemedicine platforms connect healthcare professionals & patients remotely. With secure video calls, appointment booking, & medical history tracking, we make healthcare accessible from anywhere.",
          image: "image.png",
        },

        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          title: "Patient Management Systems",
          description: "We create systems to manage patient data, appointments, & billing efficiently. Our solutions improve workflow efficiency, reduce administrative tasks, & enhance overall patient care.",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          title: "Medical Billing Software",
          description: "We develop medical billing software to simplify billing, insurance claims, & payment processing. Our solutions ensure accuracy, streamline financial processes, & support compliance with regulations.",
          image: "image.png",
        },
      ],
    },
    industryAdvertising: {
      heading:
        "Healthcare Software Security Standards & Certifications We Work With",
      discription:
        "Our clients’ data protection, security, & product compliance are our top priorities; that’s why, as a leading healthcare app development company, we comply with robust security standards & certifications in healthcare. Our healthcare software solutions will also fully comply with national, regional, & industry health standards. Our healthcare IT consultants perform vulnerability scans using the OWASP methodology & penetration testing & examine software security & compliance through audits.",
      image: "health-care-software-image.avif",
    },
    softwareSolutions: {
      heading: "Explore Our Healthcare Software Solutions",
      discription:
        "Healthcare software solutions from Bitsclan are designed to meet the specific needs of the healthcare industry to deliver efficient, personalized, & quality care. Enable data-driven decisions & transform the healthcare management process with the right healthcare software solutions.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "Healthcare CRM",
          text: "Our end to end CRM software for healthcare can automate your medical operations, enhance the patient’s journey, & help you manage the patient portal effectively.",
        },
        {
          id: 2,
          heading: "Healthcare Analytics Solutions",
          text: "Our healthcare analytics software helps your business with accurate data analysis that improves decision-making speed & gives users the ability to prepare data without writing any code.",
        },
        {
          id: 3,
          heading: "Hospital Management Software",
          text: "Our HMS - Hospital Management System helps you access patient data, manage effectively, & generate multiple records based on your requirements - location, gender, age, etc,",
        },
        {
          id: 4,
          heading: "Patient Engagement Platform",
          text: "Our Patient engagement solutions empower patients to proactively manage their health information, communicate with experts, schedule appointments & participate in treatment plans.",
        },
      ],
    },
    industryExpertise: {
      heading: "Our Expertise: Cutting-Edge Healthcare Software Development",
      discription:
        "Our healthcare software engineers take the best advantage of leveraging innovative technologies to offer smarter healthcare solutions development services.",
      accordionData: [
        {
          id: "collapseOne",
          title: "Blockchain Solutions",
          content:
            "Our blockchain-based healthcare software services ensure the secure transfer of health records & clinical trials between private blockchains for a solid long-term investment. We adhere to industry standards & security protocols.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "AI & Machine Learning",
          content:
            "Harness the power of AI & ML to enhance decision-making, automate tasks, & deliver intelligent healthcare solutions. Our advanced algorithms provide actionable insights tailored to your needs.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "Immersive Technologies (VR/AR/MR)",
          content:
            "Leverage virtual, augmented, & mixed reality to transform patient care, training, & diagnostics with immersive, cutting-edge experiences.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "Robotic Process Automation (RPA)",
          content:
            "Streamline repetitive tasks & optimize operations with RPA, enabling greater efficiency & precision in healthcare workflows.",
          expanded: false,
        },
      ],
    },
    industryFaqs: {
      heading: "Frequently Asked Questions",
      discription:
        "Find expert answers to FAQs on healthcare web application services, including deployment, benefits, & best practices.",
      faqData: [
        {
          id: "collapseOne",
          question:
            "Why is custom software development critical for healthcare facilities?",
          answer:
            "Custom software helps healthcare facilities meet specific needs, enhance operations, & deliver quality patient care",
        },
        {
          id: "collapseTwo",
          question: "What do healthcare software development companies do?",
          answer:
            "They design, develop, & implement tailored software to streamline healthcare operations & improve efficiency.",
        },
        {
          id: "collapseThree",
          question:
            "What types of custom healthcare software development solutions are available?",
          answer:
            "Solutions include EHR systems, telemedicine platforms, patient portals, & analytics tools.",
        },
        {
          id: "fourth",
          question:
            "How is custom healthcare software beneficial from ready-made solutions?",
          answer:
            "Custom software offers tailored features, scalability, & integration options to meet unique business needs.",
        },
        {
          id: "fifth",
          question:
            "Can the implemented custom healthcare be modified or expanded after its deployment?",
          answer:
            "Yes, custom software can be updated or expanded to adapt to evolving requirements & technologies.",
        },
      ],
    },
  },

  // {
  //   id: 2,
  //   metaTitle:
  //     "Fintech Software Development Services | Next-Gen Financial Solution",
  //   metaDes:
  //     "Leverage advanced fintech software for digital wallets, payment gateways, & blockchain solutions. Build secure & innovative financial apps with Bitsclan",
  //   content:
  //     "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   title: "Fintech",
  //   slug: "fintech",
  //   bannerBtnText: "Let's Get Started",
  //   bannerHeading: "Build Financial Technology Software",
  //   description:
  //     "Fintech thrives on innovation, & we’re here to drive it forward. Our AI in fintech web apps simplify complex financial processes, from secure payment systems to intelligent financial planning tools. ",
  //   icon: "/images/Fintech.png",
  //   smallIcon: "Fintech-logo.png",
  //   image: "fintech.png",
  //   bannerHeading: "Build Fintech software",
  //   bannerImage: "fintech-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Fintech.png)`,

  //   discriptionSection: {
  //     heading: "Fintech Software Expertise",
  //     discription:
  //       "We provide innovative fintech solutions, including secure payment gateways, custom banking platforms, robo-advisors, blockchain for transparent transactions, & AI-powered fraud detection. Enhance your financial operations with secure, efficient, & reliable technology.",

  //     cardHeading:
  //       "Transforming Financial Services with Cutting-Edge Technology",
  //     cardDiscripiton:
  //       "The fintech revolution is transforming how individuals & businesses engage with financial services, delivering seamless, efficient, & secure solutions. From digital payments to AI-powered fraud detection & advanced investment platforms, our innovations streamline operations & enhance user experiences. Embrace cutting-edge technology to redefine your financial services, build trust, & unlock new growth opportunities.",
  //   },

  //   statsSection: {
  //     backgroundImage: "Fintech-counter.jpeg",
  //     heading: "Lead the Future of",
  //     greenPart: "Digital Finance",
  //     discription:
  //       "Empower your business with cutting-edge fintech solutions designed to streamline operations, enhance security, & redefine financial experiences. Stay ahead in the evolving digital finance landscape.",
  //     subheading: "Your Top Fintech",
  //     greenPartSubHeading: "Consulting Firm",
  //     stats: [
  //       {
  //         count: "650+",
  //         text: "Projects Delivered in the Financial Sector",
  //       },
  //       {
  //         count: "300+",
  //         text: "Satisfied Financial Institutions",
  //       },
  //       {
  //         count: "2500+",
  //         text: "Custom Features Deployed",
  //       },
  //       {
  //         count: "95%",
  //         text: "Client Satisfaction Rate",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Fintech Software Development Services",
  //     text: "Empower your business with cutting-edge fintech software solutions designed to enhance security, efficiency, & user experiences. Transform financial operations with innovation-driven technology.",
  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Digital Banking Solutions",
  //         text: "Develop user-friendly, secure, & feature-rich online banking platforms tailored to meet the needs of modern financial institutions & their customers.",
  //        
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Payment Processing Systems",
  //         text: "Implement seamless, efficient, & secure digital payment gateways to support hassle-free transactions & enhance user trust in your services.",
  //        
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/machine-learning.png",
  //         heading: "Blockchain & Cryptocurrency Development",
  //         text: "Leverage blockchain technology to create transparent, decentralized systems that drive innovation & provide secure, scalable cryptocurrency solutions.",
  //        
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Financial Security Standards & Regulations We Comply With",
  //     discription:
  //       "In the financial sector, security & trust are essential. We adhere to global standards like PCI DSS, ensuring the highest level of payment data protection, GDPR for robust data privacy, & ISO 27001 for comprehensive information security management. Our expertise helps you stay ahead of regulatory challenges, delivering secure, compliant fintech solutions that inspire trust & confidence among your users. Partner with us for reliable, regulation-compliant financial platforms that meet the demands of today’s digital economy.",
  //     image: "Fintech-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Fintech Software Solutions",
  //     discription:
  //       "Healthcare software solutions from Bitsclan are designed to meet the specific need of the healthcare industry to deliver efficient, personalized, & quality care. Enable data-driven decisions & transform the healthcare management process with the right healthcare software solutions.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Digital Wallets",
  //         text: "Develop secure, user-friendly, & feature-rich digital wallet solutions designed to store, manage, & transact digital currencies with ease & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Stock Trading Platforms",
  //         text: "Create custom platforms equipped with advanced tools to enable seamless, efficient, & secure trading & investment experiences for users.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Loan Management Systems",
  //         text: "Design comprehensive & streamlined systems to efficiently manage loan processes, from application & disbursement to tracking repayments & settlements.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Insurance Tech Solutions",
  //         text: "Develop innovative solutions to automate, optimize, & enhance various insurance processes, improving efficiency & customer satisfaction.",
  //       },
  //     ],
  //   },
  //   industryExpertise: {
  //     heading: "Our Expertise: Leading Fintech Software Development",
  //     discription:
  //       "We craft smart financial tech solutions, focusing on secure apps, digital wallets, blockchain, & payment gateways to simplify your financial world.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Blockchain Solutions",
  //         content:
  //           "Our blockchain-powered fintech solutions ensure secure, transparent transactions, providing a reliable foundation for digital wallets, investment tools, & secure payment gateways, enhancing customer trust.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Digital Wallet Development",
  //         content:
  //           "We create secure, user-friendly digital wallets that enable seamless payments & cryptocurrency management. Our solutions prioritize safety & ease of use for both consumers & businesses.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Payment Gateway Integration",
  //         content:
  //           "Our payment gateway services streamline online transactions, ensuring secure, efficient payment processing. We integrate robust security protocols to protect sensitive financial data in real time.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Fintech Security Solutions",
  //         content:
  //           "We offer cutting-edge security solutions to protect financial applications. From secure data encryption to fraud prevention, our systems safeguard financial transactions & customer information.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Frequently Asked Questions",
  //     discription: "Address common concerns like",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question: "What technologies are used for fintech development?",
  //         answer:
  //           "We leverage cutting-edge technologies such as blockchain, artificial intelligence (AI), machine learning (ML), cloud computing, & big data analytics to build secure & innovative fintech solutions. These technologies enhance efficiency, scalability, & user experience.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "How do you ensure data security & compliance?",
  //         answer:
  //           "We adhere to globally recognized security standards such as PCI DSS, ISO 27001, & GDPR. Additionally, we implement advanced encryption protocols, multi-factor authentication, & regular security audits to protect sensitive financial data.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question: "Can you integrate with existing banking systems?",
  //         answer:
  //           "Yes, we specialize in integrating modern solutions with legacy banking systems using APIs, middleware, & other secure protocols. Our seamless integrations ensure minimal disruption while enhancing system functionality.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "How long does it take to develop a fintech solution?",
  //         answer:
  //           "The development timeline depends on the complexity & scope of your project. On average, a custom fintech solution may take 3-6 months, but smaller features or MVPs (Minimum Viable Products) can be developed more quickly.",
  //       },
  //       {
  //         id: "fifth",
  //         question: "Do you offer post-development support?",
  //         answer:
  //           "Absolutely! We provide comprehensive post-development support, including regular maintenance, feature updates, security patches, & 24/7 technical assistance to ensure the smooth operation of your fintech solution.",
  //       },
  //     ],
  //   },
  // },

  {
    id: 3,
    metaTitle:
      "Custom Retail Software Development Services | Drive Retail Success",
    metaDes:
      "Shopping online should be seamless, & our web apps make sure it is. From personalized shopping experiences to advanced inventory management, we help businesses connect with customers, grow their sales, & create lasting impressions.",
    content:
      "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
    title: "E-commerce & Retail",
    slug: "retail-ecommerce",
    description:
      "We help retailers leverage generative AI in e-commerce to enhance inventory management, deliver personalized shopping experiences, & optimize omnichannel platforms, driving higher sales & stronger customer loyalty.",
    icon: "/images/ecommerce-icon.png",
    image: "ecommerce.avif",
    bannerBtnText: "Let's Get Started",
    bannerHeading: "Build E-commerce & Retail Software",
    bannerImage: "ecommerce-detail-banner.png",
    backgroundImage: `url(/images/industry-detial-banner-bg/Retail-ecommerce.png)`,

    discriptionSection: {
      heading: "Transforming E-commerce & Retail with Innovative Technology ",
      discription:
        "The E-commerce & Retail industries are evolving rapidly, driven by customer expectations & digital transformation. From personalized shopping experiences to efficient supply chain management, our solutions empower businesses to adapt, grow, & succeed in a competitive market.",

      cardHeading: "E-commerce & Retail Expertise",
      cardDiscripiton:
        "We deliver end-to-end eCommerce solutions designed to elevate your business. Our omnichannel platforms provide a seamless shopping experience across all devices, while AI-powered product recommendations drive personalized engagement. With efficient inventory & order management, real-time tracking, & seamless payment integration, we ensure smooth & secure transactions. Our advanced data analytics offer valuable insights into customer behavior, enabling smarter decisions & fostering business growth.",
    },

    statsSection: {
      backgroundImage: "ecommerce-counter-bg.avif",
      heading: "Transform Your ",
      greenPart: "eCommerce Business",
      discription:
        "We provide smart solutions to simplify your online store, improve security, & enhance payment systems, helping you stay ahead in the fast-evolving digital shopping world.",
      subheading: "Your Top E-commerce & Retail",
      greenPartSubHeading: "Consulting Firm",
      stats: [
        {
          count: "800+",
          text: " Projects Delivered in E-commerce & Retail",
        },
        {
          count: "500+",
          text: "Satisfied Retail Brands",
        },
        {
          count: "10,000+",
          text: "Custom Features Deployed",
        },
        {
          count: "97%",
          text: "Client Satisfaction Rate",
        },
      ],
    },

    industryServices: {
      heading: "E-commerce & Retail Software Development Services",
      text: "Our E-commerce & Retail Software Development Services create customized, scalable solutions that enhance customer experiences & streamline operations. We build secure platforms that drive growth & success in the digital marketplace.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          title: "Custom eCommerce Platforms",
          description: "Develop scalable, feature-rich eCommerce platforms tailored to your unique business needs, providing an optimal shopping experience for your customers.",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          title: "Mobile Commerce Solutions",
          description: "Create seamless & secure mobile commerce solutions that offer smooth digital payment integration, enhancing user experience & trust across all mobile platforms.",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          title: "POS & Inventory Management",
          description: "Optimize your retail operations with robust POS & inventory management systems, designed to streamline stock tracking, order management, & real-time analytics.",
          image: "image.png",
        },
      ],
    },

    industryAdvertising: {
      heading: "E-commerce & Retail Security Standards We Comply With",
      discription:
        "We adhere to the highest E-commerce & Retail security standards to ensure the protection of customer data & transactions. Compliant with PCI DSS, GDPR, & ISO 27001, our solutions are built to safeguard against threats & maintain trust across all digital platforms.",
      image: "ecommerce-add.avif",
    },

    softwareSolutions: {
      heading: "Explore Our E-commerce & Retail Solutions",
      discription:
        "Explore our innovative E-commerce & Retail Solutions designed to boost growth, enhance customer experiences, & streamline operations with secure, scalable platforms & seamless integrations.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "Omnichannel Platforms",
          text: "Unify online & in-store experiences to deliver a seamless customer journey across all touchpoints, ensuring consistent & personalized engagement.",
        },
        {
          id: 2,
          heading: "Custom Marketplace Development",
          text: "Create tailored platforms that connect sellers & buyers, offering a secure & efficient environment for transactions & business growth.",
        },
        {
          id: 3,
          heading: "Logistics & Supply Chain Solutions",
          text: "Optimize delivery processes with real-time tracking & automation, ensuring faster, more reliable shipments & improved operational efficiency.",
        },
        {
          id: 4,
          heading: "Customer Loyalty Programs",
          text: "Engage customers with personalized rewards & offers that drive repeat business & strengthen brand loyalty through targeted incentives.",
        },
      ],
    },

    industryExpertise: {
      heading: "Our Expertise: Cutting-Edge E-commerce & Retail Solutions",
      discription:
        "We specialize in crafting innovative, secure, & scalable platforms that elevate customer engagement & drive business growth in the E-commerce & Retail sectors.",
      accordionData: [
        {
          id: "collapseOne",
          title: "Seamless Shopping Experiences",
          content:
            "Integrate both online & offline channels to deliver a smooth & personalized shopping journey across all customer touchpoints, ensuring satisfaction at every step.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "Custom Marketplace Solutions",
          content:
            "Design tailored platforms that connect buyers & sellers with secure & efficient transaction systems, promoting smooth commerce & business expansion.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "Personalized Customer Engagement",
          content:
            "Boost customer loyalty with personalized rewards, offers, & incentives, turning one-time shoppers into repeat customers & fostering long-term relationships.",
          expanded: false,
        },
      ],
    },

    industryFaqs: {
      heading: "E-commerce & Retail: Commonly Asked Questions",
      discription:
        "Here are answers to some of the most frequently asked questions about our E-commerce & Retail services:",
      faqData: [
        {
          id: "collapseOne",
          question:
            "What technologies do you use to build eCommerce platforms?",
          answer:
            "We use modern frameworks & tools such as Shopify, Magento, WooCommerce, ReactJS, & NodeJS to create high-performing platforms. Additionally, we incorporate cloud solutions for scalability & reliability.",
        },
        {
          id: "collapseTwo",
          question: "Can you integrate third-party tools like CRMs & ERPs?",
          answer:
            "Yes, we specialize in integrating tools like Salesforce, Zoho CRM, SAP, & Oracle ERP into eCommerce platforms to streamline business operations & improve efficiency.",
        },
        {
          id: "collapseThree",
          question: "How do you ensure fast & secure transactions?",
          answer:
            "We implement SSL/TLS encryption, tokenization, & PCI DSS compliance to safeguard transactions. Additionally, we optimize platforms for fast loading speeds, ensuring a smooth checkout experience.",
        },
        {
          id: "fourth",
          question: "Do you provide mobile app development for eCommerce?",
          answer:
            "Yes, we design & develop mobile apps for iOS & android, ensuring a responsive & engaging shopping experience across devices.",
        },
        {
          id: "fifth",
          question: "How do you handle inventory & order management?",
          answer:
            "We develop systems that provide real-time inventory tracking, automated reordering, & order fulfillment management, ensuring efficient operations for both small & large-scale businesses.",
        },
        {
          id: "sixth",
          question: "Can you help us create a custom marketplace?",
          answer:
            "Absolutely! We specialize in developing multi-vendor marketplaces tailored to your business needs, with features like seller dashboards, payment splitting, & product catalog management.",
        },
      ],
    },
  },

  {
    id: 4,
    metaTitle:
      "Real Estate Software Development | Transform Property Management",
    metaDes:
      "Finding & managing properties has never been easier. With our web apps, you can offer virtual tours, manage client relationships, & help buyers & sellers connect seamlessly. We build tools that keep real estate professionals one step ahead.",
    content:
      "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
    title: "Real Estate",
    slug: "real-estate",
    description:
      "We provide real estate professionals with property management systems, CRM platforms, & secure transaction solutions, & our AI ML engineers design intelligent tools to streamline operations & enhance client interactions.",
    icon: "/images/RealEstate.png",
    image: "realestate.png",
    bannerBtnText: "Let's Get Started",
    bannerHeading: "Build Real Estate Software",
    bannerImage: "realestate-detail-banner.png",
    backgroundImage: `url(/images/industry-detial-banner-bg/RealEstate.png)`,

    discriptionSection: {
      heading: "Transforming Real Estate with Cutting-Edge Technology",
      discription:
        "The real estate industry is embracing digital transformation to streamline property management, boost sales, & improve client interactions. Our tailored real estate solutions help businesses modernize their operations, enhance visibility, & create seamless customer experiences.",

      cardHeading: "Real Estate Technology Expertise",
      cardDiscripiton:
        "We provide innovative real estate solutions, including dynamic property listing portals, immersive virtual tours, & seamless CRM integration. Our automated lead generation & secure online transaction systems streamline operations & enhance customer experiences. Leverage cutting-edge technology to boost efficiency & drive growth in your real estate business.",
    },

    statsSection: {
      backgroundImage: "realestate-counter-bg.avif",
      heading: "Lead the Future of",
      greenPart: " Real Estate Technology",
      discription:
        "We help your business thrive with easy-to-use property management tools, real estate portals, virtual tours, & CRM systems to boost listings & lead generation.",
      subheading: "Your Top Real Estate",
      greenPartSubHeading: "Consulting Firm",
      stats: [
        {
          count: "600+",
          text: "Projects Delivered in the Real Estate Sector",
        },
        {
          count: "400+",
          text: "Satisfied Agencies & Developers",
        },
        {
          count: "5,000+",
          text: "Custom Features Deployed",
        },
        {
          count: "95%",
          text: "Client Retention Rate",
        },
      ],
    },

    industryServices: {
      heading: "Real Estate Software Development Services",
      text: "We offer custom real estate software solutions that optimize property management, enhance client engagement, & drive efficiency across operations.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          title: "Property Management Systems",
          description: "Simplify tasks like tenant management, rent collection, & maintenance scheduling with custom property management systems tailored to your business needs.",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          title: "Virtual Tour Solutions",
          description: "Bring properties to life with 360-degree virtual tours & 3D modeling, offering an immersive experience for potential buyers or renters.",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          title: "Real Estate CRMs",
          description: "Empower agents with robust CRMs for lead tracking, pipeline management, & automated follow-ups, optimizing real estate operations.",
          image: "image.png",
        },
      ],
    },

    industryAdvertising: {
      heading: "Real Estate Data Security & Compliance Standards",
      discription:
        "Ensuring data security in real estate is crucial. We comply with global data protection standards such as GDPR, SOC 2, & ISO 27001. Our advanced security measures safeguard sensitive client information, enabling secure property transactions & tenant management systems.",
      image: "realestate-add.avif",
    },

    softwareSolutions: {
      heading: "Explore Our Real Estate Software Solutions",
      discription:
        "Discover innovative real estate software solutions designed to streamline operations, enhance client interactions, & drive business growth.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "Property Portals",
          text: "Build feature-rich portals for property listings, advanced search capabilities, & seamless booking experiences.",
        },
        {
          id: 2,
          heading: "Agent Management Systems",
          text: "Streamline operations for real estate agents with robust tools for task management, client interactions, & performance tracking.",
        },
        {
          id: 3,
          heading: "Market Analytics Tools",
          text: "Gain valuable insights into property trends, pricing, & investment opportunities with powerful analytics solutions.",
        },
        {
          id: 4,
          heading: "Online Booking Platforms",
          text: "Enable secure, real-time property booking & transaction processing for enhanced user experience & trust.",
        },
      ],
    },

    industryExpertise: {
      heading: "Our Expertise: Transformative Real Estate Software Solutions",
      discription:
        "We deliver innovative & scalable real estate software solutions to simplify property management, enhance customer experiences, & optimize business operations.",
      accordionData: [
        {
          id: "collapseOne",
          title: "Feature-Rich Property Portals",
          content:
            "Develop advanced property listing platforms with powerful search capabilities, seamless booking options, & intuitive user experiences for buyers & renters.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "Agent Management Systems",
          content:
            "Empower real estate agents with tools for task automation, lead tracking, & performance analytics, streamlining their workflows & enhancing efficiency.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "Market Analytics Solutions",
          content:
            "Deliver actionable insights with tools for analyzing property trends, pricing, & market dynamics, enabling informed decision-making & better investment strategies.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "Secure Online Booking Platforms",
          content:
            "Facilitate real-time property bookings with secure transaction systems, ensuring a trustworthy & hassle-free experience for users.",
          expanded: false,
        },
      ],
    },

    industryFaqs: {
      heading: "Your Questions About Real Estate Solutions, Answered",
      discription:
        "Find answers to common questions about our innovative & secure real estate software development services:",
      faqData: [
        {
          id: "collapseOne",
          question: "Can you develop custom solutions for real estate portals?",
          answer:
            "Yes, we specialize in building custom real estate portals tailored to your business needs. From advanced property search filters to virtual tours, we deliver features that enhance user engagement & simplify operations.",
        },
        {
          id: "collapseTwo",
          question:
            "How do you ensure the security of property & transaction data?",
          answer:
            "We implement top-tier security protocols, including end-to-end encryption, multi-factor authentication, & compliance with GDPR & ISO 27001, ensuring your data remains protected.",
        },
        {
          id: "collapseThree",
          question: "Can your systems integrate with existing tools like CRMs?",
          answer:
            "Yes, our solutions can seamlessly integrate with CRMs, ERPs, & other tools to create a unified platform for real estate operations, improving efficiency & collaboration.",
        },
        {
          id: "fourth",
          question: "Do you offer solutions for virtual tours & 3D modeling?",
          answer:
            "Absolutely! We develop interactive virtual tour platforms & 3D property modeling solutions to enhance the property viewing experience for buyers & tenants.",
        },
        {
          id: "fifth",
          question: "How long does it take to build a real estate portal?",
          answer:
            "The timeline depends on the project’s complexity & scope. A standard real estate portal typically takes 3-6 months, while smaller features or MVPs (Minimum Viable Products) can be developed more quickly.",
        },
        {
          id: "sixth",
          question: "What types of real estate businesses do you work with?",
          answer:
            "We cater to real estate agencies, property developers, brokers, & property management firms, offering tailored solutions to meet diverse business needs.",
        },
      ],
    },
  },

  {
    id: 5,
    title: "Automotive & Logistics",
    slug: "automotive-logistics",
    metaTitle:
      "Automotive & Logistics Software Development | Drive Innovation & Efficiency",
    metaDes:
      "Streamline automotive & logistics operations with AI, IoT, & automation. From fleet management to supply chain optimization, we deliver software solutions that power efficiency & growth.",
    description:
      "The automotive & logistics industries are evolving fast, demanding smarter, connected solutions. Our AI-powered software streamlines vehicle tracking, fleet & warehouse management, route optimization, & customer interactions—driving efficiency, reducing costs, & enabling sustainable growth.",
    content:
      "We build advanced automotive & logistics software solutions that combine IoT, AI, & automation to optimize operations. From connected vehicles & smart warehouses to predictive maintenance & supply chain visibility, we empower businesses to stay ahead in a competitive market.",
    icon: "/images/automotive-icon.png",
    image: "automotive.avif",
    bannerHeading: "Build Automotive & Logistics Software",
    bannerBtnText: "Let's Get Started",
    bannerImage: "automotive.avif",
    backgroundImage: `url(/images/industry-detial-banner-bg/automotive.png)`,

    discriptionSection: {
      heading: "Revolutionizing Automotive & Logistics with Technology",
      discription:
        "Both automotive & logistics sectors are being reshaped by digital transformation. At Bitsclan, we design customized solutions for connected vehicles, intelligent fleet operations, route optimization, & smart warehouses. By leveraging AI & IoT, we help businesses enhance efficiency, improve safety, & scale their operations globally.",
      cardHeading: "Automotive & Logistics Technology Expertise",
      cardDiscripiton:
        "We deliver end-to-end solutions including fleet management, dealer management, supply chain optimization, predictive maintenance, & logistics tracking. Our platforms integrate with vehicles, warehouses, & logistics systems to enhance visibility, reduce downtime, & ensure smooth operations across the value chain.",
    },

    statsSection: {
      backgroundImage: "automotive-counter-bg.avif",
      heading: "Lead the Future of",
      greenPart: " Automotive & Logistics",
      discription:
        "Driving innovation with smart automotive & logistics software solutions designed for the next generation of mobility & supply chains.",
      subheading: "Your Trusted",
      greenPartSubHeading: "Automotive & Logistics Partner",
      stats: [
        {
          count: "900+",
          text: "Projects Delivered in Automotive & Logistics",
        },
        {
          count: "600+",
          text: "Businesses Empowered Globally",
        },
        {
          count: "15,000+",
          text: "Features Deployed for Fleet & Supply Chain Optimization",
        },
        {
          count: "97%",
          text: "Client Satisfaction Rate",
        },
      ],
    },

    industryServices: {
      heading: "Automotive & Logistics Software Development Services",
      text: "Transform your operations with advanced automotive & logistics software solutions that improve efficiency, ensure connectivity, & enhance supply chain visibility.",
      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          title: "Fleet & Logistics Management Systems",
          description:
            "Track vehicles, optimize routes, monitor warehouse operations, & manage maintenance with integrated fleet & logistics platforms.",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          title: "Dealer & Supply Chain Management",
          description:
            "Empower automotive dealerships & logistics providers with tools for sales, service, inventory, & end-to-end supply chain visibility.",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          title: "Connected Vehicle & Telematics",
          description:
            "Enable real-time vehicle communication, telematics, & driver assistance systems for safer & smarter mobility.",
          image: "image.png",
        },
      ],
    },

    industryAdvertising: {
      heading: "Automotive & Logistics Data Security & Compliance",
      discription:
        "We follow global standards such as ISO/SAE 21434 for automotive cybersecurity, GDPR for data protection, & ISO 28000 for logistics security. Our solutions ensure safe, compliant, & efficient exchange of data across vehicles, warehouses, & supply chains.",
      image: "automotive-add.avif",
    },

    softwareSolutions: {
      heading: "Explore Our Automotive & Logistics Software Solutions",
      discription:
        "Discover innovative software solutions designed to optimize vehicle performance, streamline fleet & logistics management, & strengthen supply chains.",
      healthcareSolutionsData: [
        {
          id: 1,
          heading: "Connected Vehicle Systems",
          text: "Enable real-time communication between vehicles, logistics hubs, & infrastructure for smarter operations.",
        },
        {
          id: 2,
          heading: "Telematics & Tracking Solutions",
          text: "Monitor vehicle performance, driver behavior, & cargo tracking with advanced telematics for reliable logistics operations.",
        },
        {
          id: 3,
          heading: "Predictive Maintenance Tools",
          text: "Use AI-powered diagnostics to reduce downtime, optimize repairs, & enhance fleet reliability.",
        },
        {
          id: 4,
          heading: "Smart Warehousing & Logistics Platforms",
          text: "Build platforms for warehouse automation, inventory tracking, & supply chain visibility to improve logistics efficiency.",
        },
        {
          id: 5,
          heading: "Electric Vehicle (EV) & Sustainable Logistics",
          text: "Develop EV-compatible fleet & logistics systems, supporting eco-friendly mobility & green supply chains.",
        },
      ],
    },

    industryExpertise: {
      heading: "Our Expertise: Advanced Automotive & Logistics Solutions",
      discription:
        "We specialize in delivering robust automotive & logistics software that powers connected vehicles, fleet optimization, & intelligent supply chain management.",
      accordionData: [
        {
          id: "collapseOne",
          title: "Connected Vehicle Systems",
          content:
            "Enable real-time communication between vehicles, drivers, & infrastructure to improve performance, safety, & efficiency.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "Fleet & Logistics Management",
          content:
            "Optimize fleet operations, logistics tracking, & warehouse management with AI-powered solutions for smooth workflows.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "Predictive Maintenance Tools",
          content:
            "Minimize downtime & reduce maintenance costs using AI-driven analytics & diagnostics for proactive maintenance.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "Telematics & Supply Chain Visibility",
          content:
            "Improve logistics transparency with real-time tracking of shipments, driver behavior, & fuel efficiency.",
          expanded: false,
        },
      ],
    },

    industryFaqs: {
      heading: "Automotive & Logistics Software Development FAQs",
      discription:
        "Here are answers to some of the most common questions about our automotive & logistics software development services:",
      faqData: [
        {
          id: "collapseOne",
          question: "Can you develop fleet & logistics management software?",
          answer:
            "Yes, we specialize in developing systems for fleet tracking, logistics optimization, & warehouse management.",
        },
        {
          id: "collapseTwo",
          question: "Do you provide connected vehicle & telematics solutions?",
          answer:
            "Absolutely. We deliver telematics systems with real-time vehicle monitoring, driver assistance, & predictive analytics.",
        },
        {
          id: "collapseThree",
          question:
            "How do you ensure the security of logistics & vehicle data?",
          answer:
            "We implement encryption, secure communication protocols, & comply with standards like ISO/SAE 21434 & ISO 28000 to ensure safe operations.",
        },
        {
          id: "fourth",
          question: "Do you integrate IoT in automotive & logistics systems?",
          answer:
            "Yes, we build IoT-enabled solutions for vehicle tracking, predictive maintenance, & smart warehouse operations.",
        },
        {
          id: "fifth",
          question: "Do you offer EV & sustainable logistics solutions?",
          answer:
            "Yes, we develop EV-compatible fleet systems & eco-friendly logistics software to support sustainable operations.",
        },
        {
          id: "sixth",
          question: "What type of businesses do you serve?",
          answer:
            "We work with automotive manufacturers, logistics providers, fleet operators, dealerships, & EV businesses, offering tailored solutions to meet diverse needs.",
        },
      ],
    },
  },

  {
    id: 6,
    title: "Education",
    metaTitle:
      "Education Software Development Services | Smart Learning Solutions",
    metaDes:
      "Empower learning with our custom education software development services. We deliver smart, scalable solutions for e-learning, virtual classrooms, & educational platforms.",
    slug: "education",
    content:
      "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
    description:
      "Education should be engaging & accessible, & our web apps make it possible. From e-learning platforms to classroom management tools, we design AI-powered education solutions that support students, educators, & institutions, bringing everyone closer to success.",
    icon: "/images/education-icon.png",
    image: "education.png",
    bannerHeading: "Build Education Software",
    bannerBtnText: "Let's Get Started",
    bannerImage: "edtech-detail-banner.png",
    backgroundImage: `url(/images/industry-detial-banner-bg/education.png)`,

    discriptionSection: {
      heading: "Revolutionizing Education with Digital Solution",
      discription:
        "The education sector is evolving rapidly, with digital tools redefining how knowledge is imparted & absorbed. From e-learning platforms to virtual classrooms, our innovative solutions enable educational institutions & EdTech companies to deliver personalized, engaging, & impactful learning experiences.",

      cardHeading: "Educational Technology Expertise",
      cardDiscripiton:
        "We develop robust Learning Management Systems (LMS) to streamline course management & student progress tracking. Our AI-powered adaptive learning platforms personalize educational content for each student, enhancing their learning experience. Additionally, we provide tools for virtual classrooms, course authoring, & student information systems (SIS), all designed to improve collaboration, content delivery, & data management in educational environments.",
    },

    statsSection: {
      backgroundImage: "edtech-counter-bd.avif",
      heading: "Lead the Future of",
      greenPart: " Education Technology",
      discription:
        "Driving innovation in education with advanced software solutions for enhanced learning experiences.",
      subheading: "Your Top Education",
      greenPartSubHeading: "Consulting Firm",
      stats: [
        {
          count: "800+",
          text: "Educational Projects Delivered",
        },
        {
          count: "1,000+",
          text: "Schools, Colleges, & Universities Digitally Transformed",
        },
        {
          count: "10M+",
          text: "Students Benefited From Our Platforms",
        },
        {
          count: "96%",
          text: "Customer Satisfaction Rate",
        },
      ],
    },

    industryServices: {
      heading: "Education Software Development Services",
      text: "Revolutionize education with innovative software solutions designed to enhance learning experiences, streamline administration, & empower institutions with cutting-edge technology.",

      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          title: "Learning Management Systems (LMS)",
          description: "Design user-friendly platforms to manage courses, track progress, & assess performance with advanced LMS solutions tailored for educational institutions.",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          title: "Virtual Classrooms",
          description: "Create interactive environments for real-time online teaching & collaboration, enhancing the learning experience for students & educators.",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/machine-learning.png",
          title: "AI-Powered Learning Tools",
          description: "Enable personalized learning experiences with AI-driven recommendations, progress analysis, & adaptive learning solutions to support diverse student needs.",
          image: "image.png",
        },
      ],
    },

    industryAdvertising: {
      heading: "Education Software Standards & Security Compliance",
      discription:
        "We adhere to industry standards & compliance requirements such as FERPA (Family Educational Rights & Privacy Act) & GDPR to ensure data privacy & security for students, educators, & institutions. Our solutions guarantee a secure & reliable learning environment.",
      image: "edtech-add.avif",
    },

    softwareSolutions: {
      heading: "Explore Our Education Software Solutions",
      discription:
        "Discover innovative & tailored education software solutions designed to streamline course management, enhance learning experiences, & empower educational institutions to drive academic success.",

      healthcareSolutionsData: [
        {
          id: 1,
          heading: "Learning Management Systems (LMS)",
          text: "Simplify course delivery, assessments, & reporting with powerful LMS solutions tailored for educational institutions.",
        },
        {
          id: 2,
          heading: "Student Information Systems (SIS)",
          text: "Manage student data, attendance, & academic records efficiently with a comprehensive SIS solution to streamline school operations.",
        },
        {
          id: 3,
          heading: "E-Learning Platforms",
          text: "Build immersive & scalable platforms for online learning, offering a flexible & engaging educational experience for students globally.",
        },
        {
          id: 4,
          heading: "Exam Management Software",
          text: "Automate exam scheduling, grading, & result tracking, enhancing efficiency & accuracy in academic assessments.",
        },
        {
          id: 5,
          heading: "Corporate Training Solutions",
          text: "Create tailored solutions for professional development, upskilling, & corporate training to boost employee performance & growth.",
        },
      ],
    },

    industryExpertise: {
      heading: "Our Expertise: Innovative Education Software Solutions",
      discription:
        "We deliver advanced software solutions tailored for educational institutions, enhancing student engagement, streamlining administration, & fostering better learning outcomes.",
      accordionData: [
        {
          id: "collapseOne",
          title: "Course Management Systems",
          content:
            "Create intuitive platforms that simplify course delivery, track student progress, & provide detailed assessments to improve teaching effectiveness & learning outcomes.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "Student Data Management Solutions",
          content:
            "Efficiently organize & manage student records, attendance, & academic performance through automated systems that reduce administrative workload & ensure data accuracy.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "Online Learning Solutions",
          content:
            "Design interactive & engaging online learning platforms that support remote education, enhance virtual classrooms, & provide rich learning experiences for students.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "Assessment & Testing Systems",
          content:
            "Streamline the entire assessment process with automated exam scheduling, grading, & result analysis, ensuring timely & transparent evaluation of student performance.",
          expanded: false,
        },
      ],
    },

    industryFaqs: {
      heading: "Education Software Development FAQs",
      discription:
        "Here are answers to some of the most common questions about our education software development services:",
      faqData: [
        {
          id: "collapseOne",
          question: "Can you build custom LMS platforms?",
          answer:
            "Yes, we specialize in creating tailor-made Learning Management Systems (LMS) with features like course management, analytics, & integrations with third-party tools.",
        },
        {
          id: "collapseTwo",
          question: "Do you provide solutions for virtual classrooms?",
          answer:
            "Absolutely! We develop virtual classroom tools with real-time video, chat, & collaboration features to enhance online teaching experiences.",
        },
        {
          id: "collapseThree",
          question:
            "What is the timeline for developing an e-learning platform?",
          answer:
            "The timeline varies depending on the project scope. Typically, a standard e-learning platform takes 4-6 months, while more advanced features may require 6-9 months.",
        },
        {
          id: "fourth",
          question: "How do you ensure student data privacy?",
          answer:
            "We follow global standards like FERPA & GDPR, incorporating robust encryption, secure authentication, & access controls to protect sensitive data.",
        },
        {
          id: "fifth",
          question: "Do you support mobile learning apps?",
          answer:
            "Yes, we design & develop mobile-friendly e-learning solutions to ensure seamless access to learning resources anytime, anywhere.",
        },
        {
          id: "sixth",
          question:
            "Can you integrate existing educational tools with your solutions?",
          answer:
            "Yes, our solutions support integrations with tools like Google Classroom, Microsoft Teams, & other third-party applications to ensure a cohesive learning experience.",
        },
      ],
    },
  },

  // {
  //   id: 7,
  //   title: "Insurance",
  //   slug: "insurance",
  //   metaTitle:
  //     "Insurance Software Development Services | Reliable Digital Solutions",
  //   metaDes:
  //     "Enhance your insurance business with our custom software development services. We build reliable digital solutions for policy management, claims processing, & customer engagement.",
  //   content:
  //     "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We make insurance processes smooth & hassle-free. Our web apps simplify claims, manage policies, & improve communication with customers. These secure & efficient solutions are built to adapt to the ever-changing needs of the insurance sector.",
  //   icon: "/images/Insurance.png",
  //   image: "insurance.png",
  //   bannerHeading: "Build Insurance Software",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "insurance-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Insurance.png)`,

  //   discriptionSection: {
  //     heading: "Transforming Insurance Through Technology",
  //     discription:
  //       "The insurance industry is experiencing a digital revolution, where technology is enabling personalized customer experiences, faster claims processing, & efficient policy management. Our cutting-edge solutions empower insurance providers to streamline operations, enhance decision-making, & deliver value to their customers.",

  //     cardHeading: "Insurance Technology Expertise",
  //     cardDiscripiton:
  //       "Streamline your insurance operations with our Claims Management Systems, Underwriting Automation, & AI-powered Predictive Analytics. Enhance customer relationships with tailored CRM solutions & simplify policy management with seamless Policy Administration.",
  //   },

  //   statsSection: {
  //     backgroundImage: "insurance-counter-bg.jpg",
  //     heading: "Lead the Future of ",
  //     greenPart: " Digital Insurance",
  //     discription:
  //       "Driving innovation in Digital Insurance with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Insurance",
  //     greenPartSubHeading: "Consulting Firm",
  //     stats: [
  //       {
  //         count: "500+",
  //         text: "Insurance Software Solutions Delivered",
  //       },
  //       {
  //         count: "200+",
  //         text: "Insurance Companies Digitally Empowered",
  //       },
  //       {
  //         count: "10M+",
  //         text: "Policies Managed Through Our Platforms",
  //       },
  //       {
  //         count: "95%",
  //         text: "Customer Retention Rate",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Insurance Software Development Services",
  //     text: "Transform your insurance business with innovative software solutions designed to streamline claims management, automate underwriting, & enhance customer relationships with advanced technology.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Claims Management Systems",
  //         text: "Simplify & automate the claims lifecycle for faster resolution & transparency, improving efficiency & customer satisfaction.",
  //         btnLink: "claims-management-systems",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Underwriting Solutions",
  //         text: "Leverage AI & machine learning for accurate risk assessment & underwriting, enhancing decision-making & operational efficiency.",
  //         btnLink: "underwriting-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/machine-learning.png",
  //         heading: "Policy Administration Software",
  //         text: "Streamline the management of insurance policies from issuance to renewal, ensuring seamless operations & customer satisfaction.",
  //         btnLink: "policy-administration-software",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Insurance Software Standards & Compliance",
  //     discription:
  //       "We adhere to regulatory standards like GDPR, HIPAA (for health insurance), & PCI DSS (for payment security) to ensure compliance, security, & data privacy in all our solutions. Our platforms are built to handle sensitive information securely & efficiently.",
  //     image: "insurance-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Insurance Software Solutions",
  //     discription:
  //       "Discover innovative & tailored insurance software solutions designed to streamline claims management, enhance underwriting accuracy, & optimize policy administration for improved business performance.",

  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Claims Management Software",
  //         text: "Enable quick & hassle-free claims processing, reducing turnaround time & enhancing customer satisfaction.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Customer Relationship Management (CRM)",
  //         text: "Optimize customer interactions, enhance retention, & drive loyalty with a comprehensive CRM solution for insurers.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Policy Administration Platforms",
  //         text: "Efficiently manage policies, renewals, & endorsements, ensuring streamlined operations & enhanced customer service.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Risk Assessment Tools",
  //         text: "Leverage AI-driven insights for accurate risk evaluations & better underwriting decisions in the insurance process.",
  //       },
  //       {
  //         id: 5,
  //         heading: "InsurTech Platforms",
  //         text: "Develop next-generation digital solutions for innovative insurance services, transforming the industry with advanced technology.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Smart & Simple Insurance Software Solutions",
  //     discription:
  //       "We create easy-to-use insurance software that helps manage policies, speed up claims, improve customer service, & make daily tasks hassle-free for insurers & agents.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Policy Management Systems",
  //         content:
  //           "Easily handle all your insurance policies in one place, from creating new ones to updating old ones. No more messy paperwork, just smooth sailing!",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Claims Processing Solutions",
  //         content:
  //           "When things go wrong, quick claims matter. This system helps speed up approvals, track progress, & get payouts without the headache.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Customer Relationship Management (CRM) for Insurance",
  //         content:
  //           "Keeping customers happy is key! Manage contacts, track conversations, & send reminders so no one feels forgotten.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Risk Assessment & Underwriting Tools",
  //         content:
  //           "Know the risks before saying yes! These tools help analyze customer details & decide the best coverage with less guesswork.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Insurance Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our insurance software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question: "Can you develop custom insurance platforms?",
  //         answer:
  //           "Yes, we specialize in creating tailor-made solutions for claims management, policy administration, & customer relationship management to meet your unique business needs.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "Do you provide AI solutions for claims processing?",
  //         answer:
  //           "Absolutely! We integrate AI into claims management systems to automate fraud detection, expedite approvals, & ensure accuracy in processing.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question: "How long does it take to build insurance software?",
  //         answer:
  //           "The timeline depends on the complexity of the project. Standard solutions take 3-6 months, while more advanced or custom platforms may take 6-12 months.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "How do you ensure compliance with industry regulations?",
  //         answer:
  //           "We follow global standards such as GDPR, HIPAA, & PCI DSS to ensure compliance & data security across all our solutions.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your platforms integrate with third-party insurance tools?",
  //         answer:
  //           "Yes, we ensure seamless integration with third-party tools like underwriting engines, payment gateways, & analytics platforms to deliver end-to-end functionality.",
  //       },
  //       {
  //         id: "sixth",
  //         question: "Do you offer mobile-friendly insurance solutions?",
  //         answer:
  //           "Yes, our solutions are fully responsive & mobile-friendly, enabling customers to access services like policy management & claims filing on the go.",
  //       },
  //     ],
  //   },
  // },

  // {
  //   id: 9,
  //   title: "Entertainment",
  //   metaTitle:
  //     "Entertainment Software Development Services | Engage Audiences with Innovative Solutions",
  //   metaDes:
  //     "Deliver captivating experiences with our entertainment software development services. We build innovative solutions for streaming, media management, & interactive content platforms.",
  //   slug: "entertainment",
  //   content:
  //     "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "Our entertainment solutions include content management systems, audience analytics platforms, & IP protection tools, optimizing content distribution & engagement.",
  //   icon: "/images/entertainment.avif",
  //   image: "entertainmentMain.png",
  //   bannerHeading: "Build Entertainment Software",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "travel-entertainment-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/entertainment.avif)`,

  //   discriptionSection: {
  //     heading: "Shaping the Future",
  //     discription:
  //       "of Entertainment, The entertainment industry thrives on creativity & innovation, requiring robust technology to deliver immersive experiences. Our entertainment software solutions empower media companies, streaming platforms, event organizers, & content creators to captivate audiences, monetize content effectively, & stay ahead in a competitive market.",

  //     cardHeading: "Entertainment Technology Expertise",
  //     cardDiscripiton:
  //       "Elevate your entertainment & event management with our cutting-edge solutions. We offer seamless video streaming platforms, efficient event management systems, & robust content management tools. Our AR/VR integration enhances engagement, while advanced ticketing & audience analytics provide valuable insights to optimize your events.",
  //   },

  //   statsSection: {
  //     backgroundImage: "entertainment-counter-bg.jpg",
  //     heading: "Lead the Future of",
  //     greenPart: "Digital Entertainment",
  //     discription:
  //       "Driving innovation in Smart Entertainment with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Entertainment",
  //     greenPartSubHeading: "Consulting Firm",
  //     stats: [
  //       {
  //         count: "800+",
  //         text: "Entertainment Projects Delivered",
  //       },
  //       {
  //         count: "500+",
  //         text: "Companies Served Globally",
  //       },
  //       {
  //         count: "98%",
  //         text: "Engagement Rate Improvement",
  //       },
  //       {
  //         count: "96%",
  //         text: "Customer Satisfaction Rate",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Entertainment Software Development Services",
  //     text: "Transform your entertainment business with innovative software solutions designed to enhance video streaming, streamline event management, & provide immersive AR/VR experiences for engaging audiences.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         title: "Video Streaming Platforms",
  //         description: "Build scalable platforms for seamless live or on-demand video streaming, ensuring high-quality user experiences.",
  //         link: "video-streaming-platforms",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         title: "Event Management Solutions",
  //         description: "Manage concerts, festivals, & conferences with efficient ticketing, audience tools, & real-time analytics.",
  //         link: "event-management-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         title: "AR/VR Experiences",
  //         description: "Integrate augmented & virtual reality for immersive entertainment experiences that engage & captivate audiences.",
  //         link: "arvr-experiences",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Entertainment Software Standards & Compliance",
  //     discription:
  //       "Our solutions align with global media standards like DASH for adaptive streaming & adhere to copyright protection regulations like DMCA. We prioritize secure data handling to protect user privacy & content integrity.",
  //     image: "entertainment-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Entertainment Software Solutions",
  //     discription:
  //       "Discover innovative & tailored entertainment software solutions designed to deliver seamless video streaming, optimize event management, & integrate immersive AR/VR experiences for enhanced audience engagement & business success.",

  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Streaming Platforms",
  //         text: "Create personalized & interactive experiences for your audience, offering seamless live & on-demand content delivery.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Event Ticketing Systems",
  //         text: "Simplify online ticket booking, seat allocation, & payments to streamline event management & enhance customer experience.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Audience Analytics Tools",
  //         text: "Leverage data to understand audience preferences & trends, optimizing content strategies & increasing engagement.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Content Distribution Networks",
  //         text: "Ensure fast & reliable content delivery worldwide, enhancing user experience & ensuring high-quality streaming.",
  //       },
  //       {
  //         id: 5,
  //         heading: "AR/VR Integration",
  //         text: "Enhance storytelling & engagement through immersive technologies, creating unforgettable experiences for your audience.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Entertainment Software Solutions",
  //     discription:
  //       "We specialize in delivering cutting-edge entertainment software solutions that power streaming platforms, streamline event management, integrate immersive AR/VR experiences, & enhance audience engagement for better performance & satisfaction.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Streaming Platforms",
  //         content:
  //           "Create seamless, scalable platforms for live & on-demand video streaming, offering personalized experiences & high-quality content delivery for global audiences.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Event Management Solutions",
  //         content:
  //           "Efficiently manage events from ticketing & seat allocation to audience engagement, simplifying logistics & enhancing customer experiences for concerts, festivals, & conferences.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Audience Analytics Tools",
  //         content:
  //           "Leverage data to understand audience preferences, enhance content strategies, & improve engagement by analyzing viewership trends & behavior.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "AR/VR Experiences",
  //         content:
  //           "Integrate immersive AR/VR technologies to create unique & interactive entertainment experiences, revolutionizing storytelling & audience engagement.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Entertainment Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our entertainment software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question: "Can you help build a scalable video streaming platform?",
  //         answer:
  //           "Yes, we specialize in creating robust & scalable platforms for live & on-demand video streaming with advanced features like content recommendation & adaptive bitrate streaming.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "How do you integrate AR/VR into entertainment software?",
  //         answer:
  //           "We design & integrate AR/VR technologies to create immersive experiences for gaming, live events, & virtual tours, enhancing user engagement.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question: "Do you offer audience analytics tools?",
  //         answer:
  //           "Absolutely! Our audience analytics tools help track user behavior, preferences, & engagement, enabling data-driven decisions to boost your entertainment platform's performance.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What kind of event management solutions do you provide?",
  //         answer:
  //           "We provide end-to-end event management solutions, including ticket booking systems, attendee tracking, & post-event analytics.",
  //       },
  //       {
  //         id: "fifth",
  //         question: "Do your platforms support multi-device compatibility?",
  //         answer:
  //           "Yes, our solutions are optimized for mobile, desktop, & smart TVs, ensuring a seamless experience across all devices.",
  //       },
  //       {
  //         id: "sixth",
  //         question: "How do you protect digital content from piracy?",
  //         answer:
  //           "We implement DRM (Digital Rights Management) & watermarking technologies to safeguard your content & prevent unauthorized access or distribution.",
  //       },
  //     ],
  //   },
  // },

  {
    id: 10,
    title: "Entertainment & Gaming",
    metaTitle:
      "Entertainment & Game Development Services | Immersive & Scalable Solutions",
    metaDes:
      "Transform your ideas into reality with our entertainment & gaming software solutions. From immersive gameplay to seamless content experiences, we deliver scalable, next-gen innovations for mobile, PC, console, & streaming platforms.",
    slug: "gaming-entertainment",
    content:
      "We create innovative entertainment & gaming solutions that combine creativity, technology, & AI to deliver unforgettable player & audience experiences. From custom games & cloud platforms to immersive AR/VR & engaging content systems, we help brands captivate audiences worldwide.",
    description:
      "We empower the entertainment & gaming industries with custom development, in-game economy platforms, player analytics, & immersive streaming solutions, enabling businesses to deliver secure, engaging, & future-ready experiences.",
    icon: "/images/industry-gaming-icon.png",
    image: "game.png",
    bannerHeading: "Build Entertainment & Gaming Software",
    bannerBtnText: "Let's Get Started",
    bannerImage: "gaming-detail-banner.png",
    backgroundImage: `url(/images/industry-detial-banner-bg/gaming.png)`,

    discriptionSection: {
      heading: "Revolutionize the",
      discription:
        "Entertainment & Gaming Industry. Today’s audiences demand immersive content & interactive gameplay. At Bitsclan, we develop software solutions that blend creativity with advanced technologies, helping studios, publishers, & entertainment providers deliver cutting-edge experiences. From mobile & console games to live-streaming & cloud platforms, we empower businesses to stand out in the digital landscape.",
      cardHeading: "Entertainment & Gaming Expertise",
      cardDiscripiton:
        "Build cross-platform games with AR/VR integration, create secure blockchain ecosystems, launch cloud gaming services for seamless access, & develop intelligent content platforms that enhance audience engagement & interactivity.",
    },

    statsSection: {
      backgroundImage: "game-counter-bg.avif",
      heading: "Lead the Future of",
      greenPart: "Entertainment & Gaming",
      discription:
        "Driving innovation with immersive experiences, smart analytics, & high-performance gaming solutions.",
      subheading: "Your Trusted",
      greenPartSubHeading: "Entertainment & Gaming Partner",
      stats: [
        {
          count: "1,200+",
          text: "Games & Entertainment Platforms Supported",
        },
        {
          count: "700+",
          text: "Studios & Enterprises Served Globally",
        },
        {
          count: "98%",
          text: "Increase in Player & Audience Engagement",
        },
        {
          count: "95%",
          text: "Client Satisfaction Rate",
        },
      ],
    },

    industryServices: {
      heading: "Entertainment & Gaming Software Development Services",
      text: "Elevate your entertainment & gaming business with powerful software solutions that enable immersive gameplay, enhance streaming platforms, & deliver AR/VR-based engagement to global audiences.",

      industryServicesSlides: [
        {
          id: 1,
          borderClass: "border-1",
          icon: "/images/icon1.svg",
          title: "Cross-Platform Game Development",
          description:
            "Build games & entertainment apps that deliver seamless experiences across mobile, console, PC, & web.",
          image: "image.png",
        },
        {
          id: 2,
          borderClass: "border-2",
          icon: "/images/icon2.svg",
          title: "AR/VR Experiences",
          description:
            "Design immersive entertainment & gaming worlds with AR/VR to engage users like never before.",
          image: "image.png",
        },
        {
          id: 3,
          borderClass: "border-1",
          icon: "/images/arvr-icon.png",
          title: "Cloud Gaming & Streaming Solutions",
          description:
            "Deliver high-quality gaming & entertainment experiences anywhere with cloud-based platforms.",
          image: "image.png",
        },
        {
          id: 4,
          borderClass: "border-2",
          icon: "/images/blockchain-icon.png",
          title: "Blockchain & In-Game Economy",
          description:
            "Develop secure, decentralized ecosystems for digital assets, NFTs, & in-game economies.",
          image: "image.png",
        },
      ],
    },

    industryAdvertising: {
      heading: "Entertainment & Gaming Standards & Compliance",
      discription:
        "Our solutions comply with global entertainment & gaming standards such as OpenGL, DirectX, & Vulkan. We ensure data security through GDPR compliance, implement anti-piracy & anti-cheat systems, & guarantee high-quality performance for all platforms.",
      image: "game-add.avif",
    },

    softwareSolutions: {
      heading: "Explore Our Entertainment & Gaming Solutions",
      discription:
        "Discover advanced solutions for gaming studios, entertainment platforms, & streaming services from AR/VR experiences to cloud gaming & in-game monetization tools.",

      healthcareSolutionsData: [
        {
          id: 1,
          heading: "Game Engines & Content Integration",
          text: "Integrate with Unity, Unreal Engine, or custom engines while supporting streaming platforms for entertainment content.",
        },
        {
          id: 2,
          heading: "AR/VR Worlds",
          text: "Deliver immersive entertainment & interactive gaming with AR/VR-based environments.",
        },
        {
          id: 3,
          heading: "Multiplayer & Live Streaming",
          text: "Enable real-time multiplayer gaming & interactive entertainment streaming with low latency.",
        },
        {
          id: 4,
          heading: "Cloud Platforms",
          text: "Create scalable, cloud-powered entertainment & gaming ecosystems accessible anywhere.",
        },
        {
          id: 5,
          heading: "In-Game & Content Monetization",
          text: "Enable secure transactions, subscriptions, & ad-based monetization for games & entertainment platforms.",
        },
      ],
    },

    industryExpertise: {
      heading: "Our Expertise: Next-Gen Entertainment & Gaming Solutions",
      discription:
        "We deliver cutting-edge software that powers immersive gaming, interactive entertainment, & cloud-based platforms for global audiences.",
      accordionData: [
        {
          id: "collapseOne",
          title: "Cross-Platform Entertainment & Gaming",
          content:
            "Build scalable & engaging platforms that unify experiences across mobile, console, PC, & web applications.",
          expanded: true,
        },
        {
          id: "collapseTwo",
          title: "AR/VR Innovation",
          content:
            "Create immersive AR/VR solutions for both gaming & entertainment, enhancing engagement & interaction.",
          expanded: false,
        },
        {
          id: "collapseThree",
          title: "Real-Time Multiplayer & Live Content",
          content:
            "Enable real-time multiplayer games & live entertainment streaming with minimal latency & global scalability.",
          expanded: false,
        },
        {
          id: "collapseFour",
          title: "Cloud Entertainment & Gaming",
          content:
            "Develop cloud-powered solutions that reduce hardware dependency & provide on-demand access to games & content anywhere.",
          expanded: false,
        },
      ],
    },

    industryFaqs: {
      heading: "Entertainment & Gaming Software Development FAQs",
      discription:
        "Here are answers to common questions about our entertainment & gaming software development services:",
      faqData: [
        {
          id: "collapseOne",
          question: "Do you develop cross-platform games & entertainment apps?",
          answer:
            "Yes, we specialize in building cross-platform games & apps that deliver seamless user experiences across mobile, PC, consoles, & web.",
        },
        {
          id: "collapseTwo",
          question:
            "How do you ensure scalability for gaming & streaming platforms?",
          answer:
            "We leverage cloud technologies & scalable architectures to support millions of users & viewers simultaneously.",
        },
        {
          id: "collapseThree",
          question: "Can you integrate AR/VR for gaming & entertainment?",
          answer:
            "Absolutely! We design immersive AR/VR-based experiences that engage both players & audiences in interactive environments.",
        },
        {
          id: "fourth",
          question: "Do you offer monetization solutions?",
          answer:
            "Yes, we build secure monetization systems including in-game purchases, subscription models, & ad-based revenue for entertainment apps.",
        },
        {
          id: "fifth",
          question: "Do you develop multiplayer & live streaming features?",
          answer:
            "Yes, we create real-time multiplayer systems, leaderboards, & live streaming integrations with low-latency performance.",
        },
        {
          id: "sixth",
          question: "Do you provide analytics tools?",
          answer:
            "We deliver analytics dashboards to track player behavior, audience engagement, & content performance for data-driven decision-making.",
        },
      ],
    },
  },

  // {
  //   id: 11,
  //   title: "Social Networking",
  //   metaTitle:
  //     "Social Networking App Development Services | Build Engaging Digital Communities",
  //   metaDes:
  //     "Create meaningful connections with our social networking app development services. We build feature-rich, scalable platforms that foster engagement & vibrant digital communities.",
  //   slug: "social-networking",
  //   content:
  //     "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We provide social platforms with user engagement analytics, content moderation tools, & secure data management systems, enhancing user interaction & privacy.",
  //   icon: "/images/SocialNetworking.png",
  //   image: "Social.png",
  //   bannerHeading: "Build Innovative Social Networking Platforms",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "social-networking-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/SocialNetworking.png)`,

  //   discriptionSection: {
  //     heading: "Empower Communities ",
  //     discription:
  //       "and Connections,  Social networking is at the heart of how we interact today, driving conversations, content sharing, & collaborations. At Bitsclan, we specialize in building robust social platforms that foster real-time communication, community engagement, & seamless content sharing. Whether it’s creating a new social platform or enhancing an existing one, we deliver innovative technology solutions that enable users to connect & interact in meaningful ways.",
  //     cardHeading: "Social Networking Software Expertise",
  //     cardDiscripiton:
  //       "Our entertainment software solutions empower community building with advanced tools for user engagement & interaction. We offer seamless content sharing, social media insights, & secure messaging features to enhance communication & drive audience interaction. These solutions create a dynamic, connected environment that fosters loyalty & boosts engagement across your platform.",
  //   },

  //   statsSection: {
  //     backgroundImage: "social-network-counter-add.png",
  //     heading: "Lead the Future of",
  //     greenPart: "Social Networking",
  //     discription:
  //       "Driving innovation in Social Networking with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Social Networking",
  //     greenPartSubHeading: "Consulting Firm",
  //     stats: [
  //       {
  //         count: "1,000+",
  //         text: "Social Platforms Built",
  //       },
  //       {
  //         count: "500+",
  //         text: "Global Social Media Solutions Delivered",
  //       },
  //       {
  //         count: "97%",
  //         text: "Increased User Engagement",
  //       },
  //       {
  //         count: "98%",
  //         text: "Customer Satisfaction Rate",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Social Networking Software Development Services",
  //     text: "Transform your entertainment business with innovative software solutions that elevate video streaming, streamline event management, & integrate immersive AR/VR experiences, driving deeper audience engagement & satisfaction.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Community Building Solutions",
  //         text: "Create robust features for building & managing online communities, enhancing engagement & interaction.",
  //         btnLink: "community-building-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Real-Time Messaging Solutions",
  //         text: "Develop secure, interactive communication tools to foster seamless & engaging user interactions.",
  //         btnLink: "real-time-messaging-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Content Sharing Platforms",
  //         text: "Build platforms enabling users to seamlessly share videos, images, & other content, fostering creativity & connection.",
  //         btnLink: "content-sharing-platforms",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Social Media Analytics Tools",
  //         text: "Integrate real-time analytics to track user engagement & interactions, optimizing content strategies.",
  //         btnLink: "social-media-analytics-tools",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Social Networking Software Standards & Compliance",
  //     discription:
  //       " Our social networking solutions comply with global data protection regulations such as GDPR & CCPA, ensuring that user privacy is respected. We also prioritize accessibility & follow web standards to ensure that our platforms are user-friendly & inclusive.",
  //     image: "social-network-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Social Networking Software Solutions",
  //     discription:
  //       "Discover innovative & tailored entertainment software solutions designed to deliver seamless video streaming, optimize event management, & integrate immersive AR/VR experiences for enhanced audience engagement & business success.",

  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Community Engagement Tools",
  //         text: "Build & manage vibrant communities with features like forums, groups, & user interactions to foster engagement.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Secure Messaging Platforms",
  //         text: "Develop real-time, encrypted messaging solutions for secure communication, ensuring user privacy & safety.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Social Media Integration",
  //         text: "Enable users to connect their accounts across various social platforms, facilitating content sharing & enhancing social interaction.",
  //       },
  //       {
  //         id: 4,
  //         heading: "User-Generated Content Systems",
  //         text: "Empower users to share content through simple & effective submission tools, promoting creativity & community participation.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Advanced Social Analytics",
  //         text: "Track interactions, likes, shares, & other key metrics to optimize user engagement & content strategies.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Social Networking Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced social networking software solutions that empower community building, real-time messaging, content sharing, & social media integration for seamless user engagement & interaction.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Community Engagement Tools",
  //         content:
  //           "Build & manage vibrant online communities with features like forums, groups, & user interactions to foster engagement & create a loyal user base.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Real-Time Messaging Solutions",
  //         content:
  //           "Develop secure, real-time messaging platforms with encrypted communication tools for enhanced user privacy & interaction.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Social Media Integration",
  //         content:
  //           "Enable users to connect their accounts across various social platforms, allowing for seamless content sharing & better social interaction.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "User-Generated Content Systems",
  //         content:
  //           "Empower users to create, share, & contribute content through simple tools, fostering creativity & community-driven platforms.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Social Networking Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our social networking software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question: "Can you develop platforms for community building?",
  //         answer:
  //           "Yes, we specialize in developing platforms that allow users to create & manage online communities, complete with group chats, forums, & user-generated content features.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question:
  //           "Do you offer messaging features for social networking apps?",
  //         answer:
  //           "Absolutely! We design secure, real-time messaging systems that allow users to chat privately, in groups, or with media sharing capabilities.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How do you integrate social media analytics tools into platforms?",
  //         answer:
  //           "We provide powerful analytics tools that track user interactions, content engagement, & social metrics, allowing you to gain insights into your platform’s performance.",
  //       },
  //       {
  //         id: "fourth",
  //         question:
  //           "What kind of features can you implement for user-generated content?",
  //         answer:
  //           "We integrate tools for users to create, upload, & share content like photos, videos, & articles, making it easy to manage & display user submissions.",
  //       },
  //       {
  //         id: "fifth",
  //         question: "Do you support third-party social media integrations?",
  //         answer:
  //           "Yes, we enable social media integrations so users can link their accounts & share content across different platforms, improving engagement & visibility.",
  //       },
  //       {
  //         id: "sixth",
  //         question: "Can you help with user privacy & data protection?",
  //         answer:
  //           "Yes, we comply with the latest data protection laws such as GDPR & provide features like data encryption & consent management to protect your users’ privacy.",
  //       },
  //     ],
  //   },
  // },

  // {
  //   id: 12,
  //   title: "Telecom",
  //   slug: "telecom",
  //   metaTitle:
  //     "Telecom Software Development Services | Empower Connectivity & Innovation",
  //   metaDes:
  //     "Drive innovation in communication with our telecom software development services. We deliver scalable solutions for network management, billing systems, & customer engagement.",
  //   content:
  //     "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "Our telecom solutions include billing management systems, network optimization tools, & customer relationship platforms, ensuring efficient operations & customer satisfaction.",
  //   icon: "/images/Telecom.png",
  //   image: "telecom.png",
  //   bannerHeading: "Transform Telecom Experiences with Cutting-Edge Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "telecom-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Telecom.png)`,

  //   discriptionSection: {
  //     heading: "Revolutionizing the ",
  //     discription:
  //       "Telecom Industry, The telecom industry is the backbone of global communication, connecting billions of people worldwide. At Bitsclan, we specialize in building advanced telecom software solutions that enhance connectivity, streamline network management, & offer next-gen communication experiences. From cloud-based solutions to mobile carrier systems, we help telecom companies deliver high-quality, scalable, & secure services that drive customer satisfaction & business growth.",

  //     cardHeading: "Telecom Software Expertise",
  //     cardDiscripiton:
  //       "We offer advanced telecom solutions, including network optimization, cloud-based systems, seamless mobile billing, real-time communication tools, & data analytics. Our services help telecom businesses improve performance, scalability, & customer experience through cutting-edge technologies.",
  //   },

  //   statsSection: {
  //     backgroundImage: "telecom-counter-add.png",
  //     heading: "Drive the Future of ",
  //     greenPart: "Telecom Innovation",
  //     discription:
  //       "Driving innovation in Telecom Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Telecom Innovation",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,000+",
  //         text: "Telecom Solutions Deployed Globally",
  //       },
  //       {
  //         count: "500+",
  //         text: "Telecom Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Retention Rate",
  //       },
  //       {
  //         count: "99.99%",
  //         text: "Uptime for Network Systems",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Telecom Software Development Services",
  //     text: "Revolutionize your telecom business with cutting-edge software solutions that optimize network performance, enhance communication tools, & provide secure, scalable services, ensuring seamless user experiences & operational efficiency.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Network Optimization Solutions",
  //         text: "Enhance network efficiency, speed, & capacity through intelligent optimization tools.",
  //         btnLink: "network-optimization-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Cloud-Based Telecom Systems",
  //         text: "Build scalable, cloud-native solutions for managing telecom infrastructure & services.",
  //         btnLink: "cloud-based-telecom-systems",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Mobile Billing & Payment Systems",
  //         text: "Design secure & efficient billing systems for mobile operators & service providers.",
  //         btnLink: "mobile-billing-and-payment-systems",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Real-Time Communication Tools",
  //         text: "Develop seamless voice, video, & messaging systems for enhanced communication.",
  //         btnLink: "real-time-communication-tools",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Telecom Software Standards & Compliance",
  //     discription:
  //       " Our telecom solutions adhere to global standards such as ETSI, 3GPP, & GSMA, ensuring interoperability across networks & platforms. We also comply with data privacy regulations like GDPR & CCPA to protect user data & ensure regulatory compliance.",
  //     image: "telecom-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Telecom Software Solutions",
  //     discription:
  //       "Discover innovative & tailored telecom software solutions designed to optimize network performance, enhance communication tools, & provide secure, scalable services for seamless user experiences & business success.",

  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Telecom Network Management",
  //         text: "Optimize & manage network performance across multiple locations to ensure reliable & efficient service delivery.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Mobile Billing Systems",
  //         text: "Implement secure, efficient, & accurate billing solutions to streamline mobile service provider operations.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Cloud Communication Platforms",
  //         text: "Build scalable cloud-based platforms for seamless voice, video, & messaging services, enhancing communication capabilities.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Customer Engagement Tools",
  //         text: "Create interactive customer service platforms with chatbots, IVR, & real-time support to improve customer satisfaction.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Telecom Analytics Solutions",
  //         text: "Utilize big data analytics to enhance network performance & provide actionable customer insights for better decision-making.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Telecom Software Solutions",
  //     discription:
  //       "We specialize in delivering cutting-edge telecom software solutions that optimize network performance, streamline billing systems, enhance real-time communication, & harness data analytics for better customer insights.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Telecom Network Management",
  //         content:
  //           "Manage & optimize network performance across multiple locations, ensuring reliable, high-quality service & enhanced operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Mobile Billing Systems",
  //         content:
  //           "Design secure, efficient, & accurate billing solutions that cater to mobile service providers, ensuring seamless payment processing & customer satisfaction.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Cloud Communication Platforms",
  //         content:
  //           "Build scalable cloud-based platforms for voice, video, & messaging services, empowering telecom providers to deliver flexible & on-demand communication solutions.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Telecom Analytics Solutions",
  //         content:
  //           "Leverage big data analytics to track & enhance network performance, improve customer experiences, & make data-driven business decisions.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Telecom Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our telecom software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question: "Can you help optimize telecom networks?",
  //         answer:
  //           "Yes, we provide network optimization solutions that enhance speed, reliability, & capacity, ensuring smooth operation across telecom systems.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "How do you ensure the security of telecom systems?",
  //         answer:
  //           "We integrate advanced security features like encryption, multi-factor authentication, & fraud detection to protect telecom systems from threats & data breaches.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question: "What is cloud-based telecom infrastructure?",
  //         answer:
  //           "Cloud-based telecom infrastructure leverages the cloud to deliver scalable, on-demand telecom services, allowing telecom providers to reduce costs & increase flexibility.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "Do you offer mobile billing solutions?",
  //         answer:
  //           "Yes, we design mobile billing systems that are secure, efficient, & capable of handling high volumes of transactions for telecom providers.",
  //       },
  //       {
  //         id: "fifth",
  //         question: "Can you integrate analytics into telecom systems?",
  //         answer:
  //           "Absolutely! We offer data analytics tools that help telecom companies optimize their network performance, track usage patterns, & gain insights into customer behavior.",
  //       },
  //       {
  //         id: "sixth",
  //         question: "Do you provide solutions for customer engagement?",
  //         answer:
  //           "Yes, we offer solutions like chatbots, IVR systems, & real-time messaging platforms that enhance customer service & engagement.",
  //       },
  //     ],
  //   },
  // },

  // {
  //   id: 13,
  //   title: "Energy",
  //   metaTitle:
  //     "Energy Software Development Services | Powering Digital Transformation",
  //   metaDes:
  //     "Accelerate innovation in the energy sector with our custom software solutions. We develop tools for energy management, smart grids, & operational efficiency.",
  //   slug: "energy",
  //   content:
  //     "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We provide advanced AI automation & workflow solutions for the energy sector. From smart grid management & resource optimization to secure trading platforms, our automated workflows help energy companies operate smarter & more efficiently.",
  //   icon: "/images/Energy.png",
  //   image: "energy.png",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },

  // {
  //   id: 14,
  //   title: "Agriculture",
  //   metaTitle:
  //     "Agriculture Software Development Services | Cultivating Smart Farming Solutions",
  //   metaDes:
  //     "Revolutionize farming with our agriculture software development services. We build smart solutions for crop management, precision farming, & supply chain optimization.",
  //   slug: "agriculture",
  //   content:
  //     "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We cultivate innovation in agriculture with precision farming technologies, AI-driven crop monitoring, & blockchain-secured supply chains, ensuring higher yields & sustainable practices.",
  //   icon: "/images/industries-icons/Agriculture.svg",
  //   image: "Agriculture.avif",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },

  // {
  //   id: 15,
  //   title: "Aviation",
  //   slug: "aviation",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We optimize aviation with AI-driven flight scheduling, predictive maintenance systems, & enhanced passenger experience platforms, ensuring efficiency & safety in every journey.",
  //   icon: "/images/industries-icons/Aviation.svg",
  //   image: "Aviation.avif",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },

  // {
  //   id: 16,
  //   title: "Construction",
  //   slug: "construction",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We drive the future of construction with AI-powered project planning, IoT-enabled site monitoring, & sustainable building technologies that reduce costs & environmental impact.",
  //   icon: "/images/industries-icons/Construction.svg",
  //   image: "Construction.avif",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 17,
  //   title: "Electric Vehicles",
  //   slug: "electric-vehicles",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We accelerate the EV revolution with smart charging networks, AI-powered energy management systems, & advanced telematics, driving the adoption of sustainable transportation solutions.",
  //   icon: "/images/industries-icons/Electric Vehicles (EV).svg",
  //   image: "Electric Vehicles (EV).png",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 18,
  //   title: "Event",
  //   slug: "event",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We accelerate the EV revolution with smart charging networks, AI-powered energy management systems, & advanced telematics, driving the adoption of sustainable transportation solutions.",
  //   icon: "/images/industries-icons/Event.svg",
  //   image: "Event.png",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 19,
  //   title: "Government",
  //   slug: "government",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We modernize government operations with secure citizen engagement platforms, AI-driven data analysis, & compliance tools, ensuring transparency, efficiency, & better public service delivery.",
  //   icon: "/images/industries-icons/Government.svg",
  //   image: "Government.png",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 20,
  //   title: "News",
  //   slug: "news",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We empower news organizations with AI-driven content generation, real-time analytics for audience engagement, & blockchain-secured publishing platforms, ensuring accurate & timely news delivery.",
  //   icon: "/images/industries-icons/News.svg",
  //   image: "News.png",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 21,
  //   title: "On Demand",
  //   slug: "on-demand",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We empower the on-demand industry with scalable platforms, real-time tracking systems, & AI-driven personalized experiences, ensuring fast, efficient, & seamless services for customers whenever they need them.",
  //   icon: "/images/industries-icons/On-Demand.svg",
  //   image: "On-Demand.png",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 22,
  //   title: "OTT (Over-The-Top)",
  //   slug: "ott",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We drive the future of OTT with personalized content recommendations, AI-powered viewer analytics, & secure streaming solutions, delivering seamless, on-demand entertainment.",
  //   icon: "/images/industries-icons/OTT (Over-The-Top).svg",
  //   image: "OTT (Over-The-Top).png",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 23,
  //   title: "Restaurant",
  //   slug: "restaurant",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We transform the restaurant industry with AI-powered menu optimization, contactless payment systems, & personalized dining experiences that cater to modern consumer preferences.",
  //   icon: "/images/industries-icons/Restaurant.svg",
  //   image: "Restaurant.png",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 24,
  //   title: "Saas",
  //   slug: "saas",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We empower SaaS companies with scalable cloud infrastructures, AI-powered customer insights, & automated service management tools, enabling them to deliver continuous value & innovation.",
  //   icon: "/images/industries-icons/Saas.svg",
  //   image: "Saas.png",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },
  // {
  //   id: 25,
  //   title: "Travel & Tourism",
  //   slug: "travel-and-tourism",
  //   content: "Lorem Ipsum is simply dummy text of the printing & typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type & scrambled it to make a type specimen book",
  //   description:
  //     "We reshape travel & tourism with AI-driven personalized travel planning, blockchain-secured bookings, & immersive virtual reality experiences, creating memorable journeys for travelers.",
  //   icon: "/images/industries-icons/Travel & Tourism.svg",
  //   image: "Travel & Tourism.png",
  //   bannerHeading: "Powering the Future with Sustainable Energy Solutions",
  //   bannerBtnText: "Let's Get Started",
  //   bannerImage: "energy-detail-banner.png",
  //   backgroundImage: `url(/images/industry-detial-banner-bg/Energy.png)`,

  //   discriptionSection: {
  //     heading: "Leading the Charge ",
  //     discription:
  //       "in Energy Innovation, The energy sector is evolving rapidly with the global push towards sustainability, efficiency, & renewable energy solutions. At Bitsclan, we empower energy providers with cutting-edge software solutions that streamline energy production, distribution, & consumption. Whether it's renewable energy management, smart grids, or energy analytics, we help businesses in the energy sector optimize operations, reduce waste, & meet sustainability goals.",

  //     cardHeading: "Energy Software Expertise",
  //     cardDiscripiton:
  //       "We offer innovative energy solutions to optimize efficiency & sustainability. Our Smart Grid Solutions enhance grid reliability & real-time monitoring. Renewable Energy Management integrates & manages renewable sources, while Energy Consumption Analytics provide insights to reduce costs. With Automated Billing & Reporting, we streamline financial processes, & our Energy Efficiency Solutions help businesses cut waste & improve performance.",
  //   },

  //   statsSection: {
  //     backgroundImage: "energy-counter-bg.jpg",
  //     heading: "Empowering the Energy ",
  //     greenPart: "Sector with Technology",
  //     discription:
  //       "Driving innovation in Energy Innovation with advanced software solutions for enhanced learning experiences.",
  //     subheading: "Your Top Energy",
  //     greenPartSubHeading: "Consulting Firm",

  //     stats: [
  //       {
  //         count: "1,500+",
  //         text: "Energy Solutions Deployed Globally",
  //       },
  //       {
  //         count: "250+",
  //         text: "Energy Providers Served",
  //       },
  //       {
  //         count: "98%",
  //         text: "Client Satisfaction Rate",
  //       },
  //       {
  //         count: "75%",
  //         text: "Reduction in Energy Waste for Clients",
  //       },
  //     ],
  //   },

  //   industryServices: {
  //     heading: "Energy Software Development Services",
  //     text: "Transform your energy business with innovative software solutions that optimize energy management, enhance efficiency, & provide scalable, secure services, driving operational excellence & sustainability.",

  //     industryServicesSlides: [
  //       {
  //         id: 1,
  //         borderClass: "border-1",
  //         icon: "/images/icon1.svg",
  //         heading: "Smart Grid Solutions",
  //         text: "Create intelligent, automated grids for efficient energy distribution & reduced downtime.",
  //         btnLink: "smart-grid-solutions",
  //         image: "image.png",
  //       },
  //       {
  //         id: 2,
  //         borderClass: "border-2",
  //         icon: "/images/icon2.svg",
  //         heading: "Renewable Energy Management",
  //         text: "Develop systems for managing renewable energy sources like solar, wind, & hydro.",
  //         btnLink: "renewable-energy-management",
  //         image: "image.png",
  //       },
  //       {
  //         id: 3,
  //         borderClass: "border-1",
  //         icon: "/images/arvr-icon.png",
  //         heading: "Energy Consumption Analytics",
  //         text: "Leverage big data to optimize energy consumption across industries & improve efficiency.",
  //         btnLink: "energy-consumption-analytics",
  //         image: "image.png",
  //       },
  //       {
  //         id: 4,
  //         borderClass: "border-2",
  //         icon: "/images/blockchain-icon.png",
  //         heading: "Automated Billing & Reporting",
  //         text: "Create automated billing systems for accurate, timely energy consumption payments.",
  //         btnLink: "automated-billing-and-reporting",
  //         image: "image.png",
  //       },
  //     ],
  //   },

  //   industryAdvertising: {
  //     heading: "Energy Software Standards & Compliance",
  //     discription:
  //       " Our energy software solutions comply with industry regulations & standards, such as ISO 50001, ANSI, & IEEE, ensuring that your operations meet global best practices. Additionally, our systems are built to adhere to environmental regulations, helping you meet sustainability goals.",
  //     image: "energy-add.jpg",
  //   },

  //   softwareSolutions: {
  //     heading: "Explore Our Energy Solutions",
  //     discription:
  //       "Discover cutting-edge energy solutions tailored to optimize resource distribution, enhance energy efficiency, & provide secure, scalable systems for sustainable business growth & operational success.",
  //     healthcareSolutionsData: [
  //       {
  //         id: 1,
  //         heading: "Smart Grid Management",
  //         text: "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance efficiency & reliability.",
  //       },
  //       {
  //         id: 2,
  //         heading: "Renewable Energy Integration",
  //         text: "Seamlessly integrate renewable energy sources such as solar & wind into your existing grid for efficient, sustainable energy use.",
  //       },
  //       {
  //         id: 3,
  //         heading: "Energy Analytics & Forecasting",
  //         text: "Gain actionable insights into energy consumption patterns, forecast future demand, & optimize resource allocation for maximum efficiency.",
  //       },
  //       {
  //         id: 4,
  //         heading: "Demand Response Systems",
  //         text: "Implement systems that dynamically manage energy consumption based on real-time demand, preventing grid overload & enhancing reliability.",
  //       },
  //       {
  //         id: 5,
  //         heading: "Energy Efficiency Solutions",
  //         text: "Identify & capitalize on opportunities to reduce energy waste & improve operational efficiency, driving sustainability & cost savings.",
  //       },
  //     ],
  //   },

  //   industryExpertise: {
  //     heading: "Our Expertise: Innovative Energy Software Solutions",
  //     discription:
  //       "We specialize in delivering advanced energy software solutions that optimize grid performance, integrate renewable energy, streamline energy analytics, & enhance demand response systems for sustainable & efficient energy use.",
  //     accordionData: [
  //       {
  //         id: "collapseOne",
  //         title: "Smart Grid Management",
  //         content:
  //           "Optimize grid performance through real-time monitoring, automation, & predictive analytics to enhance energy distribution, minimize downtime, & improve operational efficiency.",
  //         expanded: true,
  //       },
  //       {
  //         id: "collapseTwo",
  //         title: "Renewable Energy Integration",
  //         content:
  //           "Seamlessly integrate renewable energy sources, such as solar & wind, into existing grid systems to maximize energy efficiency & sustainability.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseThree",
  //         title: "Energy Analytics & Forecasting",
  //         content:
  //           "Leverage big data & advanced analytics to gain insights into energy usage patterns, forecast future demands, & optimize resource allocation for cost-effective operations.",
  //         expanded: false,
  //       },
  //       {
  //         id: "collapseFour",
  //         title: "Demand Response Systems",
  //         content:
  //           "Implement systems to manage real-time energy demand, preventing grid overload & ensuring stable, efficient energy use during peak times.",
  //         expanded: false,
  //       },
  //     ],
  //   },

  //   industryFaqs: {
  //     heading: "Energy Software Development FAQs",
  //     discription:
  //       "Here are answers to some of the most common questions about our energy software development services:",
  //     faqData: [
  //       {
  //         id: "collapseOne",
  //         question:
  //           "How can you help reduce energy consumption in our operations?",
  //         answer:
  //           "We offer energy analytics solutions that identify patterns in energy consumption, allowing you to optimize usage, reduce waste, & improve efficiency across your operations.",
  //       },
  //       {
  //         id: "collapseTwo",
  //         question: "What are smart grids & how do they work?",
  //         answer:
  //           "Smart grids are advanced electrical grids that use real-time data & automation to optimize energy distribution. They can detect issues in the grid, minimize downtime, & enable more efficient energy use by balancing supply & demand.",
  //       },
  //       {
  //         id: "collapseThree",
  //         question:
  //           "How can renewable energy be integrated into our existing systems?",
  //         answer:
  //           "We develop seamless integration solutions that allow renewable energy sources like solar, wind, & hydro to be efficiently connected to your existing energy infrastructure, helping you meet sustainability goals while maintaining grid stability.",
  //       },
  //       {
  //         id: "fourth",
  //         question: "What is energy consumption analytics?",
  //         answer:
  //           "Energy consumption analytics uses data to analyze energy usage patterns & identify areas for improvement. Our solutions provide actionable insights to reduce consumption & costs, enhancing overall operational efficiency.",
  //       },
  //       {
  //         id: "fifth",
  //         question:
  //           "Can your solutions help with energy efficiency in industrial operations?",
  //         answer:
  //           "Yes, our energy efficiency solutions are designed to optimize energy use across industrial systems. By leveraging predictive analytics & automation, we help businesses minimize waste & reduce their carbon footprint.",
  //       },
  //       {
  //         id: "sixth",
  //         question:
  //           "Do you offer solutions for managing demand-response in energy systems?",
  //         answer:
  //           "Yes, we provide demand-response systems that manage energy usage during peak demand times, preventing grid overloads & ensuring that energy is used efficiently when it's most needed.",
  //       },
  //     ],
  //   },
  // },
];

export const BannerDataEn = {
  mainHeading: "Reimagining industry with Leading Tech",
  content:
    "No matter your industry, we are your trusted partners in building state-of-the-art technology solutions.",
  btnText2: "Schedule a call for consultation!",
};

export const pioneerChangeSectionContent = {
  mainHeading: "Our Expertise Across ",
  greenHeading: "Key Industries",
  sectionDescription:
    "At Bitsclan, we don’t just serve industries—we transform them. Leveraging the latest technologies & our deep expertise, we create customized solutions that address the unique challenges faced by businesses across various sectors. From pioneering digital transformation in traditional industries to enabling the future of smart technologies, our mission is to drive meaningful change.",
};

export const hireContactIndustriesSectionContentEn = {
  mainHeading: "Industries We Serve with Expert Talent &",
  greenHeading: "Tailored Solutions",
  sectionDescription:
    "Our expertise in mobile app development extends across a wide range of industries, delivering customized solutions that meet the unique demands of each sector.",
};

export const slidesData = {
  mainHeading: "Experience The Bitsclan Advantage",
  sectionDescription:
    "We don’t just deliver services; we create lasting value for your business. Our approach is built on a foundation of deep expertise, cutting-edge technology, & a relentless commitment to excellence. When you choose Bitsclan, you’re choosing a partner dedicated to your success.",
  industryPageSliderData: [
    {
      heading: "Expertise Across Industries",
      text: "With extensive experience in diverse sectors, we bring industry-specific knowledge that drives tailored solutions, ensuring we meet your unique challenges with precision.",
    },
    {
      heading: "Cutting-Edge Technology",
      text: "We leverage the latest technologies, from AI & blockchain to advanced analytics, ensuring that your business benefits from innovative solutions that are both effective & future-proof.",
    },
    {
      heading: "Client-Centric Approach",
      text: "Your success is our priority. We take the time to understand your business, delivering customized strategies that align with your objectives & deliver measurable results.",
    },
    {
      heading: "Global Reach with Local Understanding",
      text: "With a global presence & deep local insights, we provide solutions that resonate with your market, ensuring relevance & effectiveness in every region you operate.",
    },
    {
      heading: "Innovation at the Core",
      text: "We are driven by a passion for innovation, constantly exploring new technologies & methodologies to ensure that we deliver solutions that are not just current, but ahead of the curve.",
    },
  ],
};

export var mainBannerImg = {
  backgroundImage: `url(/images/what-we-do/industy-page-box.avif)`,
};

export const staticHeading = {
  brandsBoxHeading: "Many Love Us, Others Count on Us for their Success",
  bookAnAppointment: "Book an appointment",
  getStarted: "Get Started",
  talktoExpert: "Talk to Expert",
};

export const industriesContent = {
  heading: "Delivering Measurable Impact Across Industries",
  description:
    "Our AI & IT services & solutions create long lasting competitive advantages & support diverse use cases across all major industries.",
  buttonText: "Explore All Industries",
  buttonLink: "/Industries",
  cards: [
    {
      title: "Healthcare",
      cls: "ind-blue",
      icon: "/images/heart.png",
      slug: "healthcare",
    },
    {
      title: "E-commerce & Retail",
      cls: "ind-purple",
      icon: "/images/ecommerce-icon.png",
      slug: "retail-ecommerce",
    },
    {
      title: "Real Estate",
      cls: "ind-violet",
      icon: "/images/RealEstate.png",
      slug: "real-estate",
    },
    {
      title: "Automotive & Logistics",
      cls: "ind-sky",
      icon: "/images/automotive-icon.png",
      slug: "automotive-logistics",
    },
    {
      title: "Ed-Tech",
      cls: "ind-royal",
      icon: "/images/education-icon.png",
      slug: "education",
    },
    {
      title: "Entertainment & Gaming",
      cls: "ind-sky",
      icon: "/images/Insurance.png",
      slug: "gaming-entertainment",
    },
    {
      title: "Oil & Gas",
      cls: "ind-sky",
      icon: "/images/Insurance.png",
      slug: "#",
    },
    {
      title: "Fashion & Apparels ",
      cls: "ind-sky",
      icon: "/images/Insurance.png",
      slug: "#",
    },
  ],
};

export default tabData;
